import React from 'react';
import { ButtonSize, ButtonVariant } from "../../button";
import { IconCalendar } from "../../icons";
import { useBreakpoints } from "../../responsive";
import { ScreenReaderOnly } from "../../screen-reader-only";
import { getUniqueId } from "../../utils";
import { DatePickerButton } from "../helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AccessibleDatePickerButton = function AccessibleDatePickerButton(_ref) {
  var isOpen = _ref.isOpen,
      calendarButtonAltText = _ref.calendarButtonAltText,
      iconColor = _ref.iconColor,
      toggle = _ref.toggle;

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var dialogueId = getUniqueId('AccessibleDatePickerButton');
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(DatePickerButton, {
    icon: ___EmotionJSX(IconCalendar, {
      title: calendarButtonAltText,
      color: iconColor
    }),
    iconColor: iconColor,
    onClick: toggle,
    size: ButtonSize.Small,
    variant: ButtonVariant.Tertiary,
    "aria-expanded": matches.s ? undefined : isOpen,
    "aria-describedby": matches.s ? dialogueId : undefined
  }), ___EmotionJSX(ScreenReaderOnly, {
    id: dialogueId
  }, "has pop up dialog"));
};